import { KeepAlive } from 'vue'
import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'page-404',
        component: () => import('@/views/404.vue')
    },
    {
        path: '/404',
        name: 'page-404',
        component: () => import('@/views/404.vue')
    },
    {
        path: '/wxDownload',
        name: 'wxDownload',
        component: () => import('@/views/wxDownload/index.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/wxDownload/gameDetail',
        name: 'gameDetail',
        component: () => import('@/views/wxDownload/gameDetail.vue')
    },
    {
        path: '/wxDownload2',
        name: 'wxDownload2',
        component: () => import('@/views/wxDownload/index2.vue')
    },
    {
        path: '/iosInstallGuide',
        name: 'iosInstallGuide',
        component: () => import('@/views/iosInstallGuide.vue')
    },
    {
        path: '/:shortChain', // 短链
        name: 'download',
        component: () => import('@/views/download.vue')
    },
    {
        path: '/iosInstall/:shortChain',
        name: 'iosInstall',
        component: () => import('@/views/iosInstall.vue')
    }
]

export default routes
